import styled, { css } from 'styled-components';
import { getScreenMaxWidth } from '../../utils/bundle.esm3.js';

const mapClosedPosition = (props) => {
  switch (props.position) {
    case "left":
      return `translateX(calc(${getScreenMaxWidth()} * -1))`;
    case "right":
    default:
      return `translateX(${getScreenMaxWidth()})`;
  }
};
const initialPosition = (props) => {
  switch (props.position) {
    case "left":
      return css`
        left: 0;
      `;
    case "right":
    default:
      return css`
        right: 0;
      `;
  }
};
const DrawerStyled = styled.div`
  min-height: 8px;
  min-width: 8px;
  position: fixed;
  top: 0;
  ${initialPosition};
  transition: transform 0.2s ease-out;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  &.Drawer {
    &__opened {
      transform: translateX(0);
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
    }

    &__closed {
      transform: ${mapClosedPosition};
      box-shadow: none;
    }
  }
`;

export { DrawerStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
